import api from '@pray/shared/utils/api';

// Admin-only (PB-38063): re-runs only the AI background image generation for one
// daily item — the same lambda the upload and feed-sync pipelines fire — replacing
// whatever image it has now. Quote, body and reference are left untouched.
export async function regeneratePrayRadioDailyBackgroundImage({ dailyItemId }: { dailyItemId: string }) {
  if (!dailyItemId) throw Error('Daily Item ID is required');

  const url = `/web/studio/daily-items/${dailyItemId}/regenerate-background-image`;
  const response = await api.executePostRequest(url, {});

  return response.data;
}
